export default "__VITE_ASSET__a7b21771__"